import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';

export default ArrowBackRoundedIcon;
